export default {
  methods: {
    handlerReqUpdateItem(data, optionsItem) {
      let options =
        optionsItem.length > 0 && optionsItem[0].name === "" ? [] : optionsItem;

      let prices = [
        {
          amount: this.multiplicationThousand(
            this.checkNumReplaceComma(data.variations[0].prices.exportPrice)
          ),
          priceTypeCode: "PRICE_EXPORT",
        },
        {
          amount: this.multiplicationThousand(
            this.checkNumReplaceComma(data.variations[0].prices.importPrice)
          ),
          priceTypeCode: "PRICE_IMPORT",
        },
      ];

      let variationPrices =
        options.length > 0
          ? data.variations.map((e) => {
              return {
                price: [
                  {
                    amount: this.multiplicationThousand(
                      this.checkNumReplaceComma(e.prices.exportPrice)
                    ),
                    priceTypeCode: "PRICE_EXPORT",
                    currency: "VND",
                    version: 0,
                  },
                  {
                    amount: this.multiplicationThousand(
                      this.checkNumReplaceComma(e.prices.importPrice)
                    ),
                    priceTypeCode: "PRICE_IMPORT",
                    currency: "VND",
                    version: 0,
                  },
                ],
                itemVariationId: e.itemVariationId,
              };
            })
          : false;
      
      const itemPriceId = (data.prices.length > 0 && data.prices[0].itemPriceId) ? data.prices[0].itemPriceId : ''
      const itemPriceVersion = (data.prices.length > 0 && data.prices[0].version) ? data.prices[0].version : 0
      
      return {
          price: prices,
          variationPrice: options.length === 0 ? [{ price: prices }] : variationPrices,
          id: itemPriceId,
          itemId: data.id,
          version: data.version,
          optimisticVersion: itemPriceVersion,
      };
    },
  },
};
